
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"edit-a","d":"M10.308 2.51L2.59 10.23l3.18 3.18 7.717-7.717-3.146-3.146a.642.642 0 01-.034-.036zm.899-.887l.03.03 3.141 3.139c.194-.233.314-.5.347-.77.036-.29-.04-.53-.201-.693l-1.855-1.852a.767.767 0 00-.555-.21c-.303 0-.63.127-.907.356zm-6.73 12.284L2.091 11.52l-.701 3.087 3.087-.701zM.271 15.743a.89.89 0 01-.248-.836l1.092-4.803a.898.898 0 01.24-.43L10.187.84C10.72.309 11.418 0 12.114 0c.558 0 1.078.206 1.452.583l1.856 1.852c.446.452.642 1.08.56 1.743a2.806 2.806 0 01-.822 1.634l-8.856 8.855a.904.904 0 01-.413.217L1.14 15.962A.787.787 0 01.896 16a.901.901 0 01-.625-.257z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('mask',{attrs:{"id":"edit-b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#edit-a"}})]),_c('use',{attrs:{"fill":"#8C99AD","fill-rule":"nonzero","xlink:href":"#edit-a"}}),_c('g',{attrs:{"fill":"#8C99AD","mask":"url(#edit-b)"}},[_c('path',{attrs:{"d":"M-4-5h24v24H-4z"}})])])])
          )
        }
      }
    